import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/adminPage/healthcareStart/index'
import {RouteParams} from 'types/routes'

export const HealthcareStartRoutes: RouteParams[] = [
  {
    key: 'healthcare_start',
    path: WITH_AUTH_ADMIN_PATHS.HEALTHCARE_START.INDEX,
    component: Index,
    exact: true,
  },
]
